import SVG from "react-inlinesvg";
import FormComp from '../elements/FormComp';
import { MediaBaseUrl } from '../../../../../../../actions/api';
import CheckBoxField from '../../../../../../CommonComponents/CheckboxField';
import { PopupButton } from "react-calendly";
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";

 const ActionSection = (props) => {
    const { title, subTitle, btnText, thankUMsg, logoImg, loading, submitPost, moderation, onsiteEnable, setOnsiteStatus, changeTab, tab, placeholders, closeReviewHub, titleError, subTitleError, btnTextError, thankUMsgError , onsite_language, setLanguage, backgroundImg}=props
  return (<div className="snapupAction w-100 bg-white p-4 rounded-8 shadow" id="snapUp-page">
    <div className="d-flex align-items-center justify-content-between mb-3">
        <h5 className="m-0 d-flex align-items-center">
       <Link to={`/wall/index/${localStorage.getItem('wallId')}`} ><i className="fa fa-angle-left" aria-hidden="true"></i></Link> <snap className="ms-3">SnapUp</snap>
            </h5>
        <span class="switch">
            <label>
                <label className="checkbox checkbox-outline checkbox-outline-2x checkbox-primary">
                <CheckBoxField isChecked={onsiteEnable} onChangeHandler={(e) =>setOnsiteStatus(e.target.checked)} name={`transparent`} id={`walltransparent`} text={0} />
                </label>
            </label>
        </span>
    </div>
    <div className="ra-scroll">
        <div className="ra-tab form-group mb-3">
        <label className='font-weight-bolder'>Select What To Collect From The User</label>
            <div className="ra-tab-wrap border bg-white rounded p-2 d-flex">
                <span className={`w-50 text-center d-flex align-items-center justify-content-center p-2 rounded ${tab == 2 ? "active position-relative text-white" : ""}`} onClick={tab != 2 ? () => changeTab(2) : () => { }}>
                    <FontAwesomeIcon type={'regular'} icon={'image'} iconClass={'me-2'} />
                    Visual UGC
                </span>
                <span className={`w-50 text-center d-flex align-items-center justify-content-center p-2 rounded ${tab == 1 ? "active position-relative text-white" : ""}`} onClick={tab != 1 ? () => changeTab(1) : () => { }}>
                    <FontAwesomeIcon type={'solid'} icon={'star-sharp'} iconClass={'me-2'} /> Star Review
                </span>
            </div>
        </div>
        <div className="ra-formwrap flex-grow-1">
            <div className="mb-3">
                <FormComp heading={'Background Image'} name={'backgroundImg'} placeholder={''} value={backgroundImg} type={6} {...props} />
            </div>
            <FormComp heading={'Title*'} error={titleError? 'This field is required.' : null} placeholder={placeholders.title} name={'title'} value={title} type={1} {...props} />
            <FormComp heading={'Sub Title*'} error={subTitleError? 'This field is required.' : null} placeholder={placeholders.subTitle} name={'subTitle'} value={subTitle} type={2} {...props} />
            <div className="mb-3">
                <FormComp heading={'Logo'} name={'logoImg'} placeholder={''} value={logoImg} type={6} {...props} />
            </div>
            <FormComp heading={'Submit Button Text*'} error={btnTextError ? 'This field is required.' : null} placeholder={placeholders.btnText} name={'btnText'} value={btnText} type={1} {...props} />
            <FormComp heading={'Thank you Message*'} error={thankUMsgError ? 'This field is required.' : null} placeholder={placeholders.thankUMsg} name={'thankUMsg'} value={thankUMsg} type={2} {...props} />
            <div className="form-group mb-3">
                <label className='font-weight-bolder'>Choose Language</label>
                <Dropdown className="select-language-main">
                    <Dropdown.Toggle className="select-language text-capitalize text-start w-100 border" variant="" id="dropdown-basic">
                        <img className="me-2 object-fit-contain" src={`https://cloud.tagbox.com/react-app/media/icons/flag-icon/${onsite_language || "english"}.svg`} width="20px" height="20px" /> {onsite_language || "English"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    { ["english","french","spanish","german","arabic"].map((lang) =>{
                        return <Dropdown.Item className="text-capitalize"  onClick={() => setLanguage(lang)}><img className="me-2 object-fit-contain" src={`https://cloud.tagbox.com/react-app/media/icons/flag-icon/${lang}.svg`} width="20px" height="20px" /> {lang}</Dropdown.Item>
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <div className='form-group mb-3'>
            <PopupButton url="https://calendly.com/taggbox/demo" rootElement={document.getElementById("snapUp-page")} text="Add Custom Field" className="btn btn-secondary w-100" />
            </div>
        </div>
    </div>
    <div className="ra-actions">
        <div className="moderate-public">
            <FormComp heading={''} name={'moderation'} placeholder={''} value={moderation} type={5} {...props} />
        </div>
        <button className={`btn btn-primary w-100 ${loading ? 'disabled' : ''}`} onClick={submitPost}>Save</button>
    </div>
</div>
  )
}

export default ActionSection